import axios from 'axios';
import {
  POS_CODE,
  TNKC_TOKEN,
  USER_DETAILS,
} from '../../service/constants.service';
import {AlertsService} from '../../service/alerts.service';
import {GlobalUtility} from '../../service/global-utility.service';

const state = {
  status: '',
  token: localStorage.getItem('token' || ''),
  user: {},
  userLogin: {},
  userPos : '',
  userPosCode : '',
};

const mutations = {
  auth_request(state, params) {
    state.status = 'loading';
    state.token = params.token;
    state.user = params.user;
  },

  auth_success(state, token, user) {
    state.status = 'success';
    state.token = token;
    state.user = user;
  },

  logout(state) {
    state.status = '';
    state.token = '';
    state.user = '';
    state.userLogin = '';
  },

  set_user_login(state, params){
    state.userLogin = params;
  },

  set_user_position(state,params){
    state.userPos = params.map(position => position.short_name).join('/');
    state.userPosCode = params.map(position => position.code).join('/');
    localStorage.setItem(POS_CODE,state.userPosCode);
  },
};

const actions = {
  loginUser({commit}, params) {
    return axios.post('/login', params).then((response) => {
      let token = response.data.token;
      let user = response.data.user;
      if (user != null && token != null) {
        localStorage.setItem(TNKC_TOKEN, token);
        localStorage.setItem(USER_DETAILS, JSON.stringify(user));
        let params = {
          token: token,
          user: user,
        };
        commit('auth_request',params);
        commit('set_user_login',params);
        commit('set_user_position',params.user.positions);
        return true;
      }
    }).catch((error)=>{
      // console.log(error.response.status);
      GlobalUtility.generateResponseMessage(error,'Login');
      GlobalUtility.failProgressBar();
      // commit('AUTH_REQUEST', null, null);
      if(USER_DETAILS) localStorage.removeItem(USER_DETAILS);
      return false;
    });
  },

  logOutUser({commit}) {
    return axios.get('/logout').then(()=>{
      commit('logout');
      localStorage.removeItem(USER_DETAILS);
      localStorage.removeItem(TNKC_TOKEN);
      delete axios.defaults.headers.common['Authorization'];
      return true;
    }).catch((error)=>{
      // console.log(error);
     return false;
    });
  },

  async getAuthUserDetails({commit}) {
    let userLogin = JSON.parse(localStorage.getItem(USER_DETAILS));
    if(userLogin) {
      commit('set_user_login',userLogin);
    }
  }
};

const getters = {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  setLoading: state => (state.isLoading),
  userLogin: state => state.userLogin,
  token : state => (state.token),
  userPos : state => (state.userPos),
  userPosCode : state => (state.userPosCode),
}

export default {state, actions, mutations, getters};